<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>Introduction</h3>
    </fade-in-top-title>
    <div class="container">
      <div class="introduction-wrapper">
        <fade-in-main class="introduction-group">
          <p>&#12296;コンポーネントの構成&#12297;</p>
          <div class="introduction-img-component">
            <img src="@/assets/images/introduction01.png" alt="" />
          </div>
        </fade-in-main>
        <work-contents-intro title="コンポーネントの構成の中身">
          <work-contents-block>
            <div>このサイトは、Vue.jsで制作されたポートフォリオのサイトです。共通のコンポーネント( CommonView )と、各ページに遷移するコンポーネントで構成されています。</div>
            <div>
              <img src="@/assets/images/introduction02_all_01.png" alt="">
            </div>
          </work-contents-block>
          <work-contents-block>
            <div class="work-contents-group">
              <div class="intro">
                <div>共通のコンポーネント( CommonView )</div>
              <img src="@/assets/images/introduction02_all_02.png" alt="">
              </div>
              <div class="intro">
                <div>各ページに遷移するコンポーネント</div>
              <img src="@/assets/images/introduction02_all_03.png" alt="">
              </div>
            </div>
          </work-contents-block>
        </work-contents-intro>
        <work-contents-intro title="共通のコンポーネントについて">
          <work-contents-block title="共通のコンポーネント( CommonView )">
            <div class="work-contents-group">
              <img class="intro" src="@/assets/images/introduction02_all_02.png" alt="">
              <img class="intro" src="@/assets/images/introduction02_common_01.png" alt="">
            </div>
            <ul class="list-left">
              <li>Header内は、左上の「ロゴ」と、右上の「ハンバーガーメニュー」コンポーネントをimportして構成されています。</li>
              <li>Headerの「ロゴ」は、クリックしたらTopページに遷移するよう[ router-link ]で囲ってあります。</li>
              <li>Headerの「ハンバーガーメニュー」は、[ v-on ]でクリックイベントを用意しています。クリックすると、メニューが表示・非表示されるよう、[ v-if ]で分岐させています。</li>
              <li class="list-interval">Footer内は、左下の「SNS」コンポーネントと右下の「トップへ戻るボタン」コンポーネントをimportして構成されています。</li>
              <li>Footerの「トップへ戻るボタン」は、スクロールしたら表示されるよう[ v-show ]を持たせてあります。また、クリックしたらページトップに戻るよう[ v-on ]でクリックイベントを用意しています。</li>
            </ul>
          </work-contents-block>
        </work-contents-intro>
        <work-contents-intro title="各ページに遷移するコンポーネント">
          <work-contents-block class="work-contents-page" title="Topページ">
            <router-link to="/">
              <div class="work-contents-group">
                <img class="intro" src="@/assets/images/introduction02_top_01.png" alt="">
                <img  class="intro" src="@/assets/images/introduction02_top_02.png" alt="">
              </div>
            </router-link>
            <ul>
              <li>Topページ内は、タイトルとコンテンツ用の「FadeInTopTitle」、「FadeInMain」コンポーネントをimportして構成されています。</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_top_03.png" alt=""></li>
              <li class="list-interval">「FadeInMain」コンポーネントにある３つのコンテンツは、[ dataオプション ]から[ v-for ]でループさせて表示させています。また、３つのコンテンツには[ v-on ]を持たせてあり、hoverすると[ dataオプション ]内に保持してある[ title ],[ subTitle ]が表示されます。また、クリックしたら該当のページに遷移するように、[ router-link ]も[ dataオプション ]で保持しています。</li>
              <li>「View more」をクリックしたらWorksページに遷移するよう[ router-link ]で囲ってあります。</li>
            </ul>
          </work-contents-block>
          <work-contents-block title="Worksページ">
            <router-link to="/works">
              <div class="work-contents-group">
                <img class="intro" src="@/assets/images/introduction02_works_01.png" alt="">
                <img class="intro intro-content-mini" src="@/assets/images/introduction02_works_03.png" alt="">
              </div>
            </router-link>
            <ul>
              <li>workページ内は、タイトルとコンテンツ用の[ FadeInTopTitle ],[ FadeInMain ]をimportして構成されています。</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_works_04.png" alt=""></li>
              <li class="list-interval">[ FadeInTopTitle ]の各ジャンルのタイトルをクリックすると、[ FadeInMain ]のコンテンツがフィルタリングするようになっています。</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_works_02.png" alt=""></li>
            </ul>
              <p class="list-interval">【フィルタリングの説明】</p>
            <ul class="list-left">
              <li>①[ dataオプション ]に、選択しているジャンルを格納する空の箱[ preview ]を用意   </li>
              <li>②[ dataオプション ]から[ v-for ]でループさせて５つのジャンルを表示</li>
              <li>③[ dataオプション ]から[ v-for ]でループさせて８つのコンテンツを表示</li>
              <li>④クリックしたジャンルを、空の箱[ preview ]に入れるため、[ v-model ]でデータと紐付け</li>
              <li>⑤[ v-show ]で、[ dataオプション ]のコンテンツ内にある[ display ]をバインドさせて、値が[ true ]なコンテンツのみを表示させる</li>
              <li>⑥選択したジャンルをコンテンツから探してフィルタリングするため、[ watchオプション ]で空の箱[ preview ]を監視する</li>
              <li>⑦ジャンルをクリックすると、[ preview ]にジャンルが入るため、preview() イベントが発火する</li>
              <li>⑧preview() イベントが発火したら、コンテンツの数分だけループさせて、さらにクリックしたジャンルの数分をループさせて、コンテンツ内にジャンルが含まれていたら[ display ]を[ true ]にして表示させ、含まれていない場合は[ false ]にする</li>
            </ul>
          </work-contents-block>
          <work-contents-block title="WorkContentsページ(複数ページがあるため、一部を紹介)">
            <router-link to="/work/workContents04">
              <div class="work-contents-group">
                <img class="intro" src="@/assets/images/introduction02_workContents_01.png" alt="">
                <img class="intro" src="@/assets/images/introduction02_workContents_02.png" alt="">
              </div>
            </router-link>
            <ul>
              <li>workContentsページ内は、タイトルとコンテンツ用の[ FadeInTopTitle ],[ WorkContentsTop ],[ WorkContentsTextMe ]をimportして構成されています。また、他のWorkContentsページの遷移用に[ WorkSlideLeft ],[ WorkSlideRight ]コンポーネントもimportしています。</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_workContents_03.png" alt=""></li>
              <li class="list-interval">GoogleMapsAPIを読み込むため[ GoogleMapsApiLoader ]を使用しています。</li>
              <li>[ createdオプション ]で、apiキーを取得して、mapを初期化するための関数 initializeMap() を読み込んでいます。また、Webブラウザにマーカーデータを保存するため、ローカルストレージ を読み込んでいます。</li>
              <li>[ dataオプション ]にて、googleMapの中心の座標と拡大率、複数のマーカーデータを保持しています。</li>
              <li>initializeMap()では、[ dataオプション ]に保持してある座標と中心をmapに埋め込み、マーカーデータの位置座標をループしてピンを表示しています。</li>
              <li>また、マーカーをhoverすると、駅名が表示されるようイベントを発火しております。</li>
              <li>[ TrafficLayer ]で現在の交通状況を表示しています。</li>
              <li>簡易的に他のWorkContentsページ(01〜08)に遷移するため[ WorkSlideLeft ],[ WorkSlideRight ]を[ router-link ]で囲ってあります。</li>
            </ul>
          </work-contents-block>
          <work-contents-block title="Aboutページ">
            <router-link to="/about">
              <div class="work-contents-group">
                <img class="intro" src="@/assets/images/introduction02_about_01.png" alt="">
                <img class="intro  intro-content-mini" src="@/assets/images/introduction02_about_02.png" alt="">
              </div>
            </router-link>
            <ul>
              <li>Aboutページ内は、タイトルとコンテンツ用の[ FadeInTopTitle ],[ FadeInMain ]をimportして構成されています。</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_about_03.png" alt=""></li>
            </ul>
          </work-contents-block>
          <work-contents-block title="Contactページ">
            <router-link to="/contact">
              <div class="work-contents-group">
                <img class="intro" src="@/assets/images/introduction02_contact_01.png" alt="">
                <img class="intro intro-content-mini" src="@/assets/images/introduction02_contact_03.png" alt="">
              </div>
            </router-link>
            <ul>
              <li>Contactページ内は、タイトル用に[ FadeInTopTitle ]をimportして構成されています</li>
              <li class="intro-content"><img src="@/assets/images/introduction02_contact_04.png" alt=""></li>
              <li class="list-interval">Contactページで記入用の[ Form ]ページと、確認用の[ Confirm ]ページをルーティングするため、router-viewを記載しています。</li>
              <li>
                <div class="work-contents-group">
                  <div class="intro">
                    <div>Formページ</div>
                    <img src="@/assets/images/introduction02_contact_01.png" alt="">
                  </div>
                  <div class="intro">
                    <div>Cofirmページ</div>
                    <img src="@/assets/images/introduction02_contact_02.png" alt="">
                  </div>
                </div>
              </li>
              <li class="list-interval">[ v-router ]で、Contactページの[ children ]内にそれぞれのパスを記入しており、FormページとConfirmページの親はContactページとなるので、親要素を介してデータのやりとりができる状態になっています。</li>
              <li>Formページのそれぞれの入力欄に、[ v-model ]でデータバインディング して、Confirmページの方に入力した内容が表示されます。</li>
            </ul>
          </work-contents-block>
        </work-contents-intro>
      </div>
    </div>
  </main>
</template>


<script>
export default {
  
}
</script>
<script>
import WorkContentsIntro from '@/components/WorkContentsIntro.vue';
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsBlock from '../components/WorkContentsBlock.vue';

export default {
  components: {
    FadeInMain,
    FadeInTopTitle,
    WorkContentsBlock,
    WorkContentsIntro
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 50px 0 10px 0;
  li {
  padding: 20px 10px;
  }
}

.list-left {
  li {
    text-align: left;
  }
}
.introduction-wrapper {
  margin: 100px auto;
}

.introduction-img-component {
  width: 80%;
  margin: 0 auto;
}

.intro-content {
  text-align: center;
  img {
  width: 80%;
  }
}

.intro {
  width: 47%;
    @include mobile {
    width: 100%;
    margin-bottom: 50px;
  }
}

.intro-content-mini {
    width: 30%;
    margin-right: 10%;
}

.list-interval {
  margin-top: 50px;

}

</style>